export default __webpack_public_path__ + "static/media/group.73280fde.svg";